import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody, Row, Col, Button, Label, Input } from 'reactstrap';
import { LoadingButton } from 'vl-common/src/components/LoadingButton';
import useApi from 'vl-common/src/hooks/useApi';
import { AlertMessage } from 'vl-common/src/components/AlertMessage/AlertMessage';
import { tools } from 'vl-common/src/lib/service.tools';
const EditEmailModal = ({
  title = 'Edit Email',
  subText = 'The email address edit.',
  cancelBtnHandler,
  onComplete,
  data,
  ...restProps
}) => {
  const { t } = useTranslation('common');
  const { Api, consumed } = useApi();
  const [email, setEmail] = useState('');
  const [loading_create, setLoading_create] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState({
    visibility: false,
    msg: ''
  });
  useEffect(() => {
    console.debug('data :>> ', data);
    if (data?.email) {
      setEmail(data.email);
    }
  }, [restProps.isOpen, data]);

  const changeEmailHandler = (emailText) => {
    setEmail(emailText);
  };

  const displayAlertMessage = (msg = '') => {
    setShowAlertMessage({ visibility: true, msg });
    const t = setTimeout(() => {
      setShowAlertMessage({ visibility: false, msg });
      clearTimeout(t);
    }, 7000);
  };

  const sendBtnHandler = () => {
    if (!tools.isEmailValid(email)) {
      displayAlertMessage('Email is invalid');
      return;
    }
    setLoading_create(true);

    //data.email
    Api.admin
      .changeUserEmail(email.trim(), data?.user_guid)
      .then((res) => {
        setLoading_create(false);
        if (onComplete) {
          onComplete();
        }
      })
      .catch((e) => {
        setLoading_create(false);
        if (e.response?.status) {
          const status = e.response.status;
          if (status === 409) {
            displayAlertMessage('Email address conflicts');
          } else {
            displayAlertMessage(`Error-${status}`);
          }
          consumed(e);
        }
      });
  };

  return (
    <Modal size="lg" {...restProps} centered backdrop={'static'} keyboard={false} data-testid="edit-email-modal">
      <ModalBody>
        <Row style={styles.container}>
          <Col className="vl-flex-col-start-start">
            <div style={styles.titleHolder}>
              <span style={styles.title}>{title}</span>
            </div>

            <AlertMessage message={showAlertMessage.msg} visibility={showAlertMessage.visibility} />
            <br />
            <Row style={styles.inputContainer}>
              <Col xs="12" className="vl-custom-material-input-box">
                <Label>
                  {t('Email Address')}
                  <span className="vl-product-satsuma">*</span>
                </Label>
                <Input
                  className="vl-custom-material-input"
                  style={styles.emailInput}
                  type="email"
                  placeholder={t('Enter Email Address')}
                  value={email}
                  onChange={(e) => changeEmailHandler(e.target.value)}
                />
              </Col>
            </Row>

            <div className="vl-flex-row-end" style={styles.btnsContainer}>
              <Button
                style={styles.btnGray}
                type="button"
                onClick={cancelBtnHandler}
                data-testid="cancel-edit-email-modal-button"
              >
                {t('Cancel')}
              </Button>

              <LoadingButton
                className="vl-button vl-font-regular"
                onClick={sendBtnHandler}
                loading={loading_create}
                disabled={loading_create}
                data-testid="save-edit-email-button"
              >
                {loading_create ? t('Saving...') : t('Save')}
              </LoadingButton>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export { EditEmailModal };

const styles: Record<string, React.CSSProperties> = {
  container: { padding: '30px' },
  btnMain: {
    width: '110px',
    backgroundColor: 'var(--productPrimary)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productPrimary)',
    color: 'var(--productPrimaryDark)'
  },
  btnGray: {
    width: '110px',
    backgroundColor: 'var(--productGray)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productGray)',
    marginRight: '10px'
  },
  rightButtonLink: {
    position: 'absolute',
    right: '5px',
    top: '39px',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '14px'
  },
  subText: {
    color: 'var(--productPrimaryDark)',
    fontSize: '14px',
    marginTop: '30px',
    marginBottom: '30px'
  },
  btnsContainer: { marginBottom: '30px', marginTop: '30px', width: '100%' },
  inputContainer: { position: 'relative', width: '100%' },
  title: { color: 'var(--productPink)', fontWeight: 'bold' },
  titleHolder: { fontSize: '30px' },
  emailInput: { fontWeight: '400' }
};
